import React from "react";
import PropTypes from "prop-types";
import InfoRow from "./InfoRow";

export default function CommonEventInfoRows({
  event,
  dateRange,
  peopleLabel,
  attendeesCount,
  maxParticipants,
  icon,
  peopleSuffix,
}) {
  return (
    <>
      {dateRange ? <InfoRow icon="mdi:calendar-clock" text={dateRange} /> : null}
      {event?.locationName ? <InfoRow icon="mdi:map-marker" text={event.locationName} /> : null}
      {event?.city ? <InfoRow icon="mdi:city" text={event.city} /> : null}
      <InfoRow
        icon={icon}
        text={`${peopleLabel}: ${attendeesCount}${maxParticipants ? ` / ${maxParticipants}` : ""}${peopleSuffix}`}
        bold
      />
    </>
  );
}

CommonEventInfoRows.propTypes = {
  event: PropTypes.shape({
    locationName: PropTypes.string,
    city: PropTypes.string,
  }),
  dateRange: PropTypes.string,
  peopleLabel: PropTypes.string,
  attendeesCount: PropTypes.number,
  maxParticipants: PropTypes.number,
  icon: PropTypes.string,
  peopleSuffix: PropTypes.string,
};

CommonEventInfoRows.defaultProps = {
  event: null,
  dateRange: "",
  peopleLabel: "Teilnehmer",
  attendeesCount: 0,
  maxParticipants: 0,
  icon: "mdi:account-group",
  peopleSuffix: "",
};
